import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import FunnelLayout from '@/layouts/FunnelLayout';

// Funnel Pages
const FunnelHome = lazy(() => import('@/views/funnel/Home'));
const FunnelHomeLong = lazy(() => import('@/views/funnel/HomeLong'));
const ProductSelection = lazy(() => import('@/views/funnel/ProductSelection'));
const Quote = lazy(() => import('@/views/funnel/quote/Quote'));
const QuoteResults = lazy(() => import('@/views/funnel/QuoteResults'));
const ApplyPartOne = lazy(() => import('@/views/funnel/ApplyPartOne'));
const ThankYou = lazy(() => import('@/views/funnel/ThankYou'));
const BookAppointment = lazy(() => import('@/views/funnel/BookAppointment'));
const About = lazy(() => import('@/views/funnel/About'));
const Terms = lazy(() => import('@/views/funnel/Terms'));
const Privacy = lazy(() => import('@/views/funnel/Privacy'));
const Cookies = lazy(() => import('@/views/funnel/Cookies'));
const LeaveReview = lazy(() => import('@/views/funnel/LeaveReview'));
const CustomerReviews = lazy(() => import('@/views/funnel/CustomerReviews'));

// Error Pages
const Error400 = lazy(() => import('@/views/error/400'));
const Error401 = lazy(() => import('@/views/error/401'));
const Error403 = lazy(() => import('@/views/error/403'));
const Error404 = lazy(() => import('@/views/error/404'));
const Error408 = lazy(() => import('@/views/error/408'));
const Error500 = lazy(() => import('@/views/error/500'));

const errorRoutes = [{
  path: '/error/400',
  element: <Error400 />
}, {
  path: '/error/401',
  element: <Error401 />
}, {
  path: '/error/403',
  element: <Error403 />
}, {
  path: '/error/404',
  element: <Error404 />
}, {
  path: '/error/408',
  element: <Error408 />
}, {
  path: '/error/500',
  element: <Error500 />
}];

const funnelRoutes = [{
  path: '/',
  element: <FunnelLayout><FunnelHome /></FunnelLayout>
}, {
  path: '/home-long',
  element: <FunnelLayout><FunnelHomeLong /></FunnelLayout>
}, {
  path: '/products',
  element: <FunnelLayout><ProductSelection /></FunnelLayout>
}, 
// Product-specific funnel routes (with product type in URL)
{
  path: '/:productType/quote',
  element: <FunnelLayout><Quote /></FunnelLayout>
}, {
  path: '/:productType/results',
  element: <FunnelLayout><QuoteResults /></FunnelLayout>
}, {
  path: '/:productType/part-one',
  element: <FunnelLayout><ApplyPartOne /></FunnelLayout>
}, {
  path: '/:productType/thank-you',
  element: <FunnelLayout><ThankYou /></FunnelLayout>
},
// Legacy routes (redirect to products page)
{
  path: '/quote',
  element: <Navigate to="/products" replace />
}, {
  path: '/quote-results',
  element: <Navigate to="/products" replace />
}, {
  path: '/part-one',
  element: <Navigate to="/products" replace />
}, {
  path: '/thank-you',
  element: <Navigate to="/products" replace />
},
// Other pages
{
  path: '/book-appointment',
  element: <FunnelLayout><BookAppointment /></FunnelLayout>
}, {
  path: '/about',
  element: <FunnelLayout><About /></FunnelLayout>
}, {
  path: '/terms',
  element: <FunnelLayout><Terms /></FunnelLayout>
}, {
  path: '/privacy',
  element: <FunnelLayout><Privacy /></FunnelLayout>
}, {
  path: '/cookies',
  element: <FunnelLayout><Cookies /></FunnelLayout>
}, {
  path: '/leave-review',
  element: <FunnelLayout><LeaveReview /></FunnelLayout>
}, {
  path: '/reviews',
  element: <FunnelLayout><CustomerReviews /></FunnelLayout>
}];

// Catch-all route for 404 - must be last
const catchAllRoute = {
  path: '*',
  element: <Error404 />
};

export const routes = [...funnelRoutes, ...errorRoutes, catchAllRoute];